import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import as from "./locales/as.json";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English",  native: "English" },
  { code: "hi", label: "Hindi",    native: "हिन्दी" },
  { code: "as", label: "Assamese", native: "অসমীয়া" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    interpolation: { escapeValue: false },
    resources: {
      en: { translation: en },
      hi: { translation: hi },
      as: { translation: as },
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "gd_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
